export const financeMonths = [
    { value: '01', label: 'finance:month_january' },
    { value: '02', label: 'finance:month_february' },
    { value: '03', label: 'finance:month_march' },
    { value: '04', label: 'finance:month_april' },
    { value: '05', label: 'finance:month_may' },
    { value: '06', label: 'finance:month_june' },
    { value: '07', label: 'finance:month_july' },
    { value: '08', label: 'finance:month_august' },
    { value: '09', label: 'finance:month_september' },
    { value: '10', label: 'finance:month_october' },
    { value: '11', label: 'finance:month_november' },
    { value: '12', label: 'finance:month_december' },
];
